import i18n from "@microdoing/shared/i18n";
import { Box, MainText } from "app/components/common";
import normalize from "app/utils/normalize";
import React from "react";
import { StyleSheet, View, Image } from "react-native";
import * as Animatable from "react-native-animatable";
import { widthPercentageToDP } from "react-native-responsive-screen";
const jouviePicture = require("../../../assets/images/jouvie.png");

const animation = {
  0: {
    opacity: 0,
    translateX: -50,
  },
  1: {
    opacity: 1,
    translateX: 0,
  },
};

const styles = StyleSheet.create({
  main: {
    marginTop: 30,
    width: widthPercentageToDP("100%"),
    display: "flex",
    flexDirection: "row",
    marginLeft: -32,
  },
  picture: {
    marginTop: normalize(-15),
    width: normalize(50),
    height: normalize(120),
  },
  bubble: {
    marginLeft: normalize(15),
    marginRight: normalize(8),
    width: normalize(15),
    height: normalize(12),
    borderWidth: 1,
    borderColor: "#EDEDED",
    borderRadius: normalize(15),
  },
});

const JouvieAllowNotification = ({}) => {
  return (
    <Box width="100%" display="flex" flexDirection="row">
      <Animatable.View useNativeDriver animation={animation} duration={250}>
        <Image source={jouviePicture} style={styles.picture} />
      </Animatable.View>
      <View style={styles.bubble} />
      <Box
        maxWidth={normalize(240)}
        maxHeight={normalize(80)}
        borderRadius={normalize(15)}
        borderWidth={1}
        borderColor="neutral.300"
        paddingVertical="s"
        paddingHorizontal="m"
        overflow="visible"
      >
        <MainText variant="l4-regular">{i18n.t("jouvie-progress")}</MainText>
      </Box>
    </Box>
  );
};

export default JouvieAllowNotification;
